import { ISearchParams } from 'interfaces'
import { Key, useEffect, useState } from 'react'
import { useLocation } from 'react-router'
import qs from 'qs'
import { dateService } from 'services'

function useSearchQueryString(profileTypeId?: Key) {
  const { search } = useLocation()
  const [searchParams, setSearchParams] = useState<ISearchParams>()

  useEffect(() => {
    const search_params: ISearchParams = {}
    if (search) {
      const query_string = qs.parse(search.substring(1))

      if (profileTypeId) search_params.profileTypeId = profileTypeId

      if (!!!profileTypeId && query_string.p) search_params.profileTypeId = query_string.p as string
      if (query_string.c) search_params.cityId = query_string.c as string
      if (query_string.df) search_params.dateFrom = dateService.baseParseDateString(query_string.df as string)
      if (query_string.dt) search_params.dateTo = dateService.baseParseDateString(query_string.dt as string)
      if (query_string.ce) search_params.eventCode = query_string.ce as string
      if (query_string.r && (query_string.r as string[]).length > 0)
        search_params.guestsPerRoom = (query_string.r as string[]).map((gpr) => parseInt(gpr))
    }
    setSearchParams(search_params)
  }, [search])

  return { searchParams, queryString: search.substring(1) }
}

export default useSearchQueryString
